// HEAL-47 — отправка причины падения на бэкенд.
//
// Критерий приёмки тикета: «в систему добавлено логирование причины критической
// ошибки». Без него диагностика белого экрана упирается в «дайте телефон тестера»:
// стек живёт в консоли устройства, до которой у нас нет доступа.
//
// Три ограничения, заложенные сознательно:
//   1. НИКОГДА не роняет приложение. Оно вызывается из componentDidCatch — падение
//      репортера поверх уже случившегося падения превратит понятный экран ошибки
//      обратно в белый.
//   2. Не более `MAX_REPORTS` отправок за сессию. Циклическая ошибка отрисовки
//      способна выстрелить сотнями раз подряд — это и есть тот самый нагрев из
//      тикета, только уже с нашей стороны.
//   3. Отправляем ТОЛЬКО техническую часть: сообщение, стек, цепочку компонентов,
//      путь без query-строки. Ни значений показателей, ни имён, ни email — это
//      медицинские данные, им в логах не место.

import { api } from '@/api/client';
import { APP_VERSION_LINE } from '@/lib/app-version';

const MAX_REPORTS = 3;
const MAX_FIELD_LENGTH = 2000;

let sent = 0;

export type ClientErrorPayload = {
  scope: string;
  message: string;
  stack: string | null;
  componentStack: string | null;
};

/** Для тестов: сбросить счётчик отправок. */
export function resetClientErrorReporter(): void {
  sent = 0;
}

function trim(value: string | null): string | null {
  if (value === null) return null;
  return value.length > MAX_FIELD_LENGTH ? value.slice(0, MAX_FIELD_LENGTH) : value;
}

export function reportClientError(payload: ClientErrorPayload): void {
  try {
    if (sent >= MAX_REPORTS) return;
    sent += 1;

    void api
      .post('/client-errors', {
        scope: payload.scope,
        message: trim(payload.message),
        stack: trim(payload.stack),
        component_stack: trim(payload.componentStack),
        // pathname без search: в query может лежать email из deep-link'а.
        path: typeof window === 'undefined' ? null : window.location.pathname,
        app_version: APP_VERSION_LINE,
      })
      // Сеть недоступна / 500 / 401 — молча. Мы уже в обработке падения, второй
      // ошибки здесь быть не должно.
      .catch(() => undefined);
  } catch {
    // Даже синхронный сбой (нет window, сломан api-клиент) не должен всплыть выше.
  }
}
